export const BASE_URL = process.env.REACT_APP_API_URL;
export const UI_APP_URL = process.env.REACT_APP_WEB_URL;
export const DEVELOPMENT_MODE = process.env.REACT_APP_ENV;
export const PAGE_SIZE = +process.env.REACT_APP_PRIMARY_PAGE_SIZE!;
export const PAGE_SIZES = +process.env.REACT_APP_SECONDARY_PAGE_SIZE!;
export const SITE_TITLE = process.env.REACT_APP_SITE_TITLE;
export const MAINTENANCE_URL = "../../../maintenance.html";